<template>
    <div class="card">
      <div class="card-header">
        <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" data-target="#personalSettingsCollapse" aria-expanded="false" aria-controls="personalSettingsCollapse">
          <i v-if="open" class="fas fa-angle-up"></i>
          <i v-else class="fas fa-angle-down"></i>
          <h4 data-target="#personalSettingsCollapse" aria-expanded="false" aria-controls="personalSettingsCollapse" class="btn alert-heading font-18 text-dark">Անձնական տվյալներ</h4>
        </button>
      </div>
      <div id="personalSettingsCollapse" class="collapse multi-collapse">
        <div class="card-body d-flex flex-column">
            <div>
              <form class="form-parsley" :key="type">
                <!-- Email / Phone -->
                <div class="form-row">
                  <div class="col-md-6 mb-3 px-md-3">
                    <label>{{$t('home.subscribe-area.placeholder')}}</label>
                    <input
                      id="email"
                      v-model="$v.fields.email.$model"
                      type="email"
                      class="form-control"
                      :class="{'border-danger': isInvalidField('email', 'required') || isInvalidField('email', 'email')}"
                      name="r_mail"
                    />
                    <div v-if="isInvalidField('email', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                    <div v-if="isInvalidField('email', 'email')" class="small text-danger">{{ $t('state_customer.valid_2') }}</div>
                  </div>
                  <div class="col-md-6 mb-3 px-md-3">
                    <label>{{$t('private_customer.user_name_surname')}}</label>
                    <input
                      v-model="$v.fields.name.hy.$model"
                      type="text"
                      name="company_name"
                      class="form-control"
                      :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                    />
                    <div v-if="isInvalidField('name.hy', 'required')"
                      class="small text-danger">{{ $t('state_customer.valid_1') }}
                    </div>
                  </div>

                  <div class="col-md-6 mb-3 px-md-3">
                    <label>{{ $t('private_customer.user_name_surname_ru') }}</label>
                    <input
                      v-model="$v.fields.name.ru.$model"
                      type="text"
                      name="company_name_ru"
                      class="form-control"
                      :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                    />
                    <div v-if="isInvalidField('name.ru', 'required')"
                      class="small text-danger">{{ $t('state_customer.valid_1') }}
                    </div>
                  </div>
                </div>

                <!-- User Name -->
                <div>
                  <div class="form-row">
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>{{$t('state_customer.pl_tel')}}</label>
                        <the-mask
                          id="phone"
                          v-model="$v.fields.phone.$model"
                          :validCharactersOnly="true"
                          class="form-control"
                          mask="###-##-##-##" 
                          name="r_phone"
                        />
                    </div>
                    <div class="col-md-6 mb-3 px-md-3">
                      <label>Տիպ՝ </label>
                      <h5>{{ getDivisionType(+me.divisions) }}</h5>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="bg-white w-100 pr-0 text-right" style="bottom: 0">
              <button @click="save" type="button" class="btn btn-primary  waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                  Պահպանել
              </button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'personalSettings',
  data () {
    return {
      open: false,
      isInvalidPhone: false,
      type: 'legalEntity',
      agreeToTerms: false,
      captcha: false,
      errorMsgFromApi: '',
      fields: {
        name: {
          hy: '',
          ru: '',
        },
        email: '',
        phone: '',
      },
      userType: this.$route.params.type,
      isPrivate: this.$route.params.type === 'private'
    }
  },
  validations: {
    fields: {
      email: { required, email },
      name: { hy: { required }, 
              ru: { required } 
      },
      phone: {},
    },
  },
  computed: {
    isCoordinator(){
       return +this.me.divisions === 2
    },
    me() {
      return this.$store.getters['user/me']
    },
  },
  created(){
    this.fields.email = this.me.email;
    this.fields.phone = this.me.phone;
    this.fields.name.hy = this.me.name;
    this.fields.name.ru = this.me.name_ru;
  },
  watch: {
    me(newValue, oldValue) {
      this.fields.name.hy = newValue.name;
      this.fields.email = newValue.email;
      this.fields.phone = newValue.phone;
      this.fields.name.ru = newValue.name_ru;
    },
  },
  methods: {
    consoleLog(e){
      console.log(e)
    },
    getDivisionType(division){
      switch (division) {
        case 1:
          return 'Պատասխանատու ստորաբաժանում';
        case 2:
          return 'Համակարգող';
        case 3:
          return 'Բաժին';
        case 4:
          return 'Վարչություն';
        default:
          break;
      }
    },
    save() {
      this.$v.fields.$touch()
      if(!this.$v.fields.$invalid) {
        $client.put(`user`, this.fields).then(({data}) => {
          if(data.data){
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Հաջողությամբ պահպանված է'
            })
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Էլ. հացեն զբաղված է',
            text: 'Կրկին փորձեք!'
          })
        })
      } else {
        this.$v.fields.$touch()
      }
    },
    isInvalidField (pathToField, validator) {
      const keyArr = pathToField.split('.')
      const field = keyArr.reduce((acc, key) => {
        return acc[key]
      }, this.$v.fields)
      return validator === 'required' ?
        field.$dirty && !field.required :
        field.required && !field[validator]
    }
  },
}
</script>
